export const environment = {
  production: false,
  keycloak: {
    issuer: origin + '/iam/realms/dashboard',
    redirectUri: origin + '/dashboard',
    logoutRedirectUri: origin,
    clientId: 'dashboard-frontend',
    scope: 'openid profile email offline_access',
  },
};
